<template functional>
  <a
    v-if="$options.DisplayValue(props) !== 0"
    href="#"
    @click="$options.Selected(props)"
    :class="$options.setClassColor(props.rowValue)"
  >
    {{ $options.DisplayValue(props) }}
  </a>
</template>

<script>
import { formatMonto } from "@/utils";
//import { Console } from "console";

export default {
  name: "Hyperlink",
  data() {
    return {
      classColor: "red"
    };
  },
  Selected(props) {
    //console.log("hyperlink selected: " + props);
    if (props.month != 24) {
      props.OpenSelection(
        props.month,
        props.row,
        props.row.ExecutiveName,
        props.rowValue
      );
    } else {
      props.OpenEntryDetails(props.row);
    }
  },

  DisplayValue(props) {
    //console.log("hyperlink DisplayValue: " + props);
    const thisDate = new Date();
    const toMonth = thisDate.getMonth() + 1;
    let valueReturn;
    const type = props.getType;
    var _type = String;
    if (type === "Cantidad") {
      _type = `${props.column}${type !== "Cantidad" ? "Amount" : ""}`;
    } else {
      _type = `${props.column}${type !== "Cantidad" ? "" : "Amount"}`;
    }
    if (
      type === "Monto" &&
      props.column !== "EntryNo" &&
      props.column !== "DocumentNo"
    ) {
      const MothValue = Number(props.row[_type]);
      if (MothValue > 0) {
        return formatMonto(MothValue);
      } else {
        return 0;
      }
    }
    /*
    console.log(
      "row: ",
      props.row,
      "\n type: ",
      _type,
      "column:",
      props.column
    );
    */
    var MothValue;
    if (isNaN(Number(props.row[_type]))) {
      MothValue = props.row[_type];
    } else {
      MothValue = Number(props.row[_type]);
    }

    //console.log("MothValue type: ", typeof MothValue);
    if (props.column === "EntryNo") {
      valueReturn = Number(MothValue).toFixed(0);
    } else if (props.column === "DocumentNo") {
      valueReturn = MothValue;
      //console.log("value: ", valueReturn);
    } else {
      valueReturn = Number(MothValue).toFixed(2) + " %";
    }

    if (Number(MothValue).toFixed(0) > 0 || isNaN(MothValue)) {
      return valueReturn;
    } else {
      /*
    else if ( MothValue.includes("RI")) {
      return valueReturn;
    }
    */
      if (props.month > toMonth) {
        //console.log("month: ", toMonth);
        return null;
      } else return valueReturn;
    }
  },
  setClassColor(val) {
    if (Number(val).toFixed(0) < 80) {
      this.classColor = "red";
      return this.classColor;
    } else if (Number(val).toFixed(0) >= 80 && Number(val).toFixed(0) <= 99) {
      this.classColor = "golden";
      return this.classColor;
    } else if (Number(val).toFixed(0) > 99) {
      this.classColor = "green";
      return this.classColor;
    }
    // else if (isNaN(val)) {
    //   this.classColor = "green";
    //   return this.classColor;
    // } else if (Number(val).toFixed(0) >= 71 && Number(val).toFixed(0) <= 81) {
    //   this.classColor = "orange";
    //   return this.classColor;
    // }
  }
};
</script>
<style scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.golden {
  color: orange;
}
</style>
